import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomFieldTypeClient, CustomFieldTypeView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CustomFieldTypeService {
    constructor(readonly client: CustomFieldTypeClient) {}

    async getAll(): Promise<CustomFieldTypeView[]> {
        return await lastValueFrom(this.client.customFieldTypeGetAll());
    }
}
